import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserProfile from './UserProfile';
import SavedPosts from './SavedPosts';
import JobPostGenerator from './JobPostGenerator';
import SubscriptionPanel from './SubscriptionPanel';
import SettingsPanel from './SettingsPanel';
import ResourcesPanel from './ResourcesPanel';
import WelcomeModal from './WelcomeModal';
import { User, Tab } from '../lib/types';

interface DashboardProps {
  user: User;
  onLogout: () => void;
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}

const Dashboard: React.FC<DashboardProps> = ({ user, onLogout, activeTab, onTabChange }) => {
  const navigate = useNavigate();
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  useEffect(() => {
    const hasSeenWelcome = localStorage.getItem(`welcome_seen_${user.id}`);
    if (!hasSeenWelcome) {
      setShowWelcomeModal(true);
    }
  }, [user.id]);

  const handleCloseWelcomeModal = () => {
    setShowWelcomeModal(false);
    localStorage.setItem(`welcome_seen_${user.id}`, 'true');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'account':
        return <UserProfile user={user} onLogout={onLogout} />;
      case 'posts':
        return <SavedPosts user={user} />;
      case 'write':
        navigate('/générer');
        return null;
      case 'bank':
        return <SubscriptionPanel user={user} />;
      case 'setup':
        navigate('/settings');
        return null;
      case 'learn':
        return <ResourcesPanel />;
      default:
        return <SavedPosts user={user} />;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      {renderContent()}
      
      <WelcomeModal 
        isOpen={showWelcomeModal} 
        onClose={handleCloseWelcomeModal} 
      />
    </div>
  );
};

export default Dashboard;